// material
import {Box} from '@material-ui/core';

// ----------------------------------------------------------------------

export default function MspLogo({ ...other }) {
    return (
        <Box {...other}>
            <svg
                viewBox="0 0 1192 260"
                xmlns="http://www.w3.org/2000/svg"
                xmlSpace="preserve"
                style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: 2,
                }}
                {...other}
            >
                <path
                    style={{
                        fill: "none",
                    }}
                    d="M235.932 141.855h413.095V413.17H235.932z"
                    transform="matrix(2.88438 0 0 .95818 -680.518 -135.922)"
                />
                <path
                    d="M337.437 36.159c0-19.314-15.68-34.994-34.994-34.994H87.054c-19.314 0-34.994 15.68-34.994 34.994v135.568c0 19.314 15.68 34.994 34.994 34.994h215.389c19.314 0 34.994-15.68 34.994-34.994V36.159Zm-28.163-7.318c0-.492-.4-.892-.892-.892H80.514c-.493 0-.892.4-.892.892v150.402c0 .492.399.892.892.892h227.868c.492 0 .892-.4.892-.892V28.841ZM387.136 219.842H1.089v16.627c0 12.148 9.848 21.997 21.997 21.997H364.9c12.281 0 22.236-9.956 22.236-22.237v-16.387Zm-174.671 15.133c0-.769-.625-1.393-1.393-1.393H178.21c-.769 0-1.393.624-1.393 1.393v2.786c0 .769.624 1.393 1.393 1.393h32.862c.768 0 1.393-.624 1.393-1.393v-2.786Z"
                    style={{
                        fill: "#81368b",
                    }}
                />
                <path
                    style={{
                        fill: "#81368b",
                    }}
                    d="M345.969 190.349h38.696v14.999h-38.696zM345.969 225.597h38.696v19.146h-38.696z"
                    transform="translate(-258.888 -152.347)"
                />
                <path
                    style={{
                        fill: "#81368b",
                    }}
                    d="M345.969 225.597h38.696v19.146h-38.696z"
                    transform="translate(-258.314 -125.142)"
                />
                <path
                    style={{
                        fill: "#81368b",
                    }}
                    d="M345.969 225.597h38.696v19.146h-38.696z"
                    transform="translate(-85.208 -151.097)"
                />
                <path
                    style={{
                        fill: "#81368b",
                    }}
                    d="M345.969 225.597h38.696v19.146h-38.696z"
                    transform="translate(-84.62 -124.294)"
                />
                <path
                    style={{
                        fill: "#81368b",
                    }}
                    d="M345.969 225.597h38.696v19.146h-38.696z"
                    transform="translate(-84.481 -98.613)"
                />
                <path
                    style={{
                        fill: "#81368b",
                    }}
                    d="M345.969 225.597h38.696v19.146h-38.696z"
                    transform="translate(-83.78 -74.462)"
                />
                <path
                    style={{
                        fill: "#81368b",
                    }}
                    d="M345.969 279.331h38.696v43.298h-38.696zM390.853 226.847h120.788v45.949H390.853zM390.853 279.331h57.487v43.298h-57.487zM456.185 279.331h55.457v43.298h-55.457z"
                    transform="translate(-258.888 -152.347)"
                />
                <text
                    x={448.222}
                    y={94.858}
                    style={{
                        fontFamily: "'Arial-BoldMT','Arial',sans-serif",
                        fontWeight: 700,
                        fontSize: 96,
                        fill: "#81368b",
                    }}
                    transform="translate(-52.583 59.97)"
                >
                    My School Portal
                </text>
            </svg>
        </Box>
    );
}
